// GENERATED from dictator/tokens.tsv by generate.py -- DO NOT EDIT BY HAND.
export const abbrsDotted: string[] = [
  'a.e.s.',
  'a.l.',
  'a.l.l.',
  'a.m.k.',
  'a.ö.l.',
  'ca.',
  'c.d.',
  'c.v.',
  'dig.',
  'd.t.',
  'e.a.',
  'e.a.a.',
  'e.a.s.',
  'e.o.',
  'e.s.',
  'e.t.',
  'e.t.v.',
  'g.s.',
  'g.v.',
  'h.g.',
  'hæ.',
  'i.a.',
  'i.s.',
  'i.t.',
  'i.v.',
  'klst.',
  'k.r.',
  'm.a.',
  'm.k.',
  'm.l.d.',
  'm.t.t.',
  'nr.',
  'p.o.',
  'p.s.',
  'sbr.',
  's.c.',
  'sek.',
  'sj.',
  'sl.',
  'stk.',
  't.d.',
  't.i.v.',
  't.o.m.',
  'v.',
  'vi.',
  'æ.v.',
  'þ.á.m.',
];
